import "./HeaderMenu.scss";

import React, { FC, useLayoutEffect, useState } from "react";
import SocialMenu from "../SocialMenu";
import { getCurrentLanguage } from "../../../../i18n";
import { t } from "i18next";
import { getSectionSlug, YouplanetSections } from "../../../../constants/general";
import ContactMarquee from '../../../Layout/ContactMarquee';

export interface HeaderMenuProps {
  isOpened: boolean;
  alternativeSlug?: string;
  alternativeText?: string;
}

interface MenuItem {
  title: string;
  description: string;
  link: string | YouplanetSections;
  target?: undefined | '_blank';
}

const HeaderMenu: FC<HeaderMenuProps> = ({ isOpened, alternativeSlug, alternativeText }) => {

  const [menuItems, setMenuItems] = useState<MenuItem[]>([]);

  useLayoutEffect(() => {
    const currentLanguage = getCurrentLanguage();
    setMenuItems([
      {
        title: t('menu.projects.title'),
        description: t('menu.projects.description'),
        link: getSectionSlug(YouplanetSections.ProjectList, currentLanguage),
      },
      {
        title: t('menu.agency.title'),
        description: t('menu.agency.description'),
        link: getSectionSlug(YouplanetSections.Agency, currentLanguage),
      },
      {
        title: t('menu.talents.title'),
        description: t('menu.talents.description'),
        link: getSectionSlug(YouplanetSections.TalentList, currentLanguage),
      },
      {
        title: t('menu.network.title'),
        description: t('menu.network.description'),
        link: getSectionSlug(YouplanetSections.Network, currentLanguage),
      },
      {
        title: t('menu.producer.title'),
        description: t('menu.producer.description'),
        link: getSectionSlug(YouplanetSections.Producer, currentLanguage),
      },
      {
        title: t('menu.pictures.title'),
        description: t('menu.pictures.description'),
        link: 'https://www.youplanetpictures.com/',
        target: '_blank',
      },
      {
        title: t('menu.team.title'),
        description: t('menu.team.description'),
        link: getSectionSlug(YouplanetSections.Team, currentLanguage),
      },
      {
        title: t('menu.press.title'),
        description: t('menu.press.description'),
        link: getSectionSlug(YouplanetSections.PressList, currentLanguage)
      }
    ]);
  }
  , []);

  return (
    <div className={`header-menu ${isOpened ? "header-menu--opened" : "header-menu--closed"}`}>
      <div className='header-menu__content'>
        <nav className='header-menu__nav'>
          <ul className="header-menu__general">
            {menuItems.map(item => (
                <li className="header-menu__general__item" key={item.link}>
                  <a
                    className="header-menu__general__link"
                    href={item.link}
                    target={item.target}>
                      {item.title}
                  </a>
                  <div className="header-menu__general__description">
                    <p>
                      {item.description}
                    </p>
                    <div className="header-menu__general__arrow"></div>
                  </div>
                </li>
              ))}
          </ul>
        </nav>
        <SocialMenu isOpened={isOpened} />
      </div>
      <div className='header-menu__contact'>
        <ContactMarquee isOpened  alternativeSlug={alternativeSlug} alternativeText={alternativeText} />
      </div>
    </div>
  );
};

export default HeaderMenu;
